// Client for the KryptaMail crypto-service (PQC E2E).
// The webmail calls this to seal (encrypt+sign) and open (verify+decrypt)
// messages. Served same-origin under /crypto behind the PQC proxy.

export class CryptoClient {
  constructor({ baseUrl = '/crypto' } = {}) {
    this.baseUrl = baseUrl;
  }

  async _post(path, body) {
    const res = await fetch(`${this.baseUrl}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `crypto ${path} failed: ${res.status}`);
    return data;
  }

  async _get(path) {
    const res = await fetch(`${this.baseUrl}${path}`);
    if (!res.ok) throw new Error(`crypto ${path} failed: ${res.status}`);
    return res.json();
  }

  lookupRecipient(address) {
    return this._get(`/v1/directory/lookup?address=${encodeURIComponent(address)}`)
      .catch(() => null);
  }

  // Seal a plaintext body to a recipient. Returns the PQC envelope.
  seal({ from, to, plaintext, recipientKemPublicKey, senderSigPrivateKey }) {
    return this._post('/v1/seal', {
      from, to,
      created: Math.floor(Date.now() / 1000),
      plaintext,
      recipientKemPublicKey,
      senderSigPrivateKey,
    });
  }

  // Open (verify + decrypt) a PQC envelope.
  open({ envelope, recipientKemPrivateKey, senderSigPublicKey }) {
    return this._post('/v1/open', { envelope, recipientKemPrivateKey, senderSigPublicKey });
  }

  suites() { return this._get('/v1/suites'); }
}
